import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"container\">&copy; {{this.date}} {{this.text}} {{yield}}</div>",{ moduleName: "sh-www/components/sh-copyright.hbs" })